import React from 'react';

const CollapseIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="490"
    height="490"
    viewBox="0 0 18 18">
    <path fill="#3FB0E8" fillRule="evenodd" d="M18 0.079L18 1.421 0 1.421 0 0.079z" transform="translate(0 8.25)"/>
  </svg>
);

export default CollapseIcon;
